const jobsDbLogoPalette = {
  standard: {
    circle: "#0d3880",
    arrow: "#fff",
    text: "#000"
  },
  inverted: {
    circle: "#fff",
    arrow: "none",
    text: "#fff"
  }
};
export {
  jobsDbLogoPalette
};
